var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { eBranches } from "sb-helpers";
import { Scoreboards } from "../../constants";
export var mapGameScore = function (x) {
    var emptyScore = {
        homeScore: "",
        awayScore: "",
        additionalScores: {},
        combinedSecondTierScores: []
    };
    x.score = __assign({}, emptyScore, x.score);
    x.scoreboard = Scoreboards[eBranches[x.sportId]] && __assign({}, Scoreboards.Empty(), Scoreboards[eBranches[x.sportId]](x));
    return x;
};
//# sourceMappingURL=mapGameScore.js.map